import bg from '../assets/pattern.png';
import * as React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { socket } from '../fetchoptions';
import makeId from '../features/makeId';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';

type Inputs = {
	roomname: string,
};

export default function NewRoom () {
	let { profile } = useSelector((state: RootState) => state.user);
	const { register, handleSubmit, formState: { errors }, reset } = useForm<Inputs>();
	const onSubmit: SubmitHandler<Inputs> = data => {
		socket.emit(
			'create-room', {
			user: profile,
			room: { id: makeId(7), name: data.roomname, createdBy: profile.username }
		})
		reset();
	};
	return (
		<>
			<img src={bg} alt="Background" className='h-52 w-full object-cover' />
			<div className='bg-["../assets/profilebg.jpg"]'></div>
			<h3 className='text-center text-xl mt-4 font-serif'>Create Room</h3>
			<form onSubmit={handleSubmit(onSubmit)} className='px-4 py-6 text-sm my-4 border-t dark:border-gray-600'>
				<div className="flex">
					<div className='w-full mb-4'>
						<label >Room name</label>
						<input {...register("roomname", { required: true })} className=' p-2 border w-full rounded outline-none dark:bg-slate-600 dark:border-slate-500' />
						{errors.roomname && <small className='text-red-400'>Room name field is required</small>}
					</div>
				</div>
				<Button onClick={handleSubmit(onSubmit)} size='small' className='float-right' variant='contained'>Create</Button>
			</form>
		</>
	)
}
